export type { Face } from './voxelTypes';
import type { Face } from './voxelTypes';

// Face type using string enum for orientation


// Helper to convert Face to normal vector (for rendering)
export function faceToNormal(face: Face): { x: number; y: number; z: number } {
  switch (face) {
    case 'x+': return { x: 1, y: 0, z: 0 }
    case 'x-': return { x: -1, y: 0, z: 0 }
    case 'y+': return { x: 0, y: 1, z: 0 }
    case 'y-': return { x: 0, y: -1, z: 0 }
    case 'z+': return { x: 0, y: 0, z: 1 }
    case 'z-': return { x: 0, y: 0, z: -1 }
  }
}

// Helper to convert normal vector to Face
export function normalToFace(normal: { x: number; y: number; z: number }): Face | undefined {
  if (normal.x === 1 && normal.y === 0 && normal.z === 0) return 'x+'
  if (normal.x === -1 && normal.y === 0 && normal.z === 0) return 'x-'
  if (normal.x === 0 && normal.y === 1 && normal.z === 0) return 'y+'
  if (normal.x === 0 && normal.y === -1 && normal.z === 0) return 'y-'
  if (normal.x === 0 && normal.y === 0 && normal.z === 1) return 'z+'
  if (normal.x === 0 && normal.y === 0 && normal.z === -1) return 'z-'
  return undefined
}
